module.exports = __webpack_public_path__ + "static/media/9.c2a2bf8c.jpg";